import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function HeaderLogoIcon({ className = "", ...props }) {
  return (
    <React.Fragment>
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-tip
        data-for="header-logo-icon"
        className={className}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44 27H29V51H44C47.866 51 51 47.866 51 44V34C51 30.134 47.866 27 44 27ZM41 32H34V46H46V37L41 32Z"
          fill="white"
        />
        <path d="M41 32L46 37H41V32Z" fill="#59E19A" />
      </svg>
      <ReactTooltip
        id="header-logo-icon"
        place="right"
        className="tooltip-cls menu-icon-tooltip"
      >
        Dashboard
      </ReactTooltip>
    </React.Fragment>
  );
}
